import { message } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
    ModalItem,
} from "../../../../Components/Items";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import etiquetaTaxidermiaPdf from "../../../../Pdf/etiquetaTaxidermiaPdf";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

class ModalEtiquetaLote extends Component {
    state = {
        loading: false,
        pdf: null,
    };
    componentDidUpdate(prevProps) {
        if (this.props.visible !== prevProps.visible && this.props.visible)
            this.consultarTodo();
    }
    async consultarTodo() {
        this.setState({ loading: true });
        await axios
            .post(
                "lotes/datosEtiquetaPdf",
                { loteId: this.props.loteId, empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    const pdf = pdfMake.createPdf(etiquetaTaxidermiaPdf(res.data));
                    this.setState(
                        {
                            loading: false,
                            pdf: pdf,
                            factura: res.data.factura
                        },
                        () => {
                            pdf.open({}, window.frames["etiquetaPdf"]);
                        }
                    );
                }else {
                    message.warning("No se encontraron datos para generar la etiqueta del lote");
                    this.setState({ loading: false });
                }
            });
        this.setState({ loading: false });
    }
    cerrarModalEtiquetaLote() {
        this.props.cerrarModalEtiquetaLote();
    }
    render() {
        return (
            <ModalItem
                title="Etiqueta"
                visible={this.props.visible}
                spinning={this.state.loading}
                onCancel={this.cerrarModalEtiquetaLote.bind(this)}
                paddingTop
            >
                <iframe
                    title={"etiqueta"}
                    style={{ width: "100%", height: "100vh" }}
                    id="etiquetaPdf"
                    name="etiquetaPdf"
                />
            </ModalItem>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
    };
};

export default connect(mapStateToProps)(ModalEtiquetaLote);
